export default __webpack_public_path__ + "static/media/s1fs4p61.f2dd6a72.jpg";